import { environment } from "../../environments/environment";

export const superAdminHttpVersion = {
    V1: environment.apiMiddlewareUrlForSuperAdmin + 'webapi/v1/superadmin/',
};

export enum superAdminHttpRoutes {
    LOGIN = 'login',
    SAVE_LOGIN_HISTORY = 'save-login-out-details',
    LOGIN_HISTORY_GET_TABLE = 'login-out-history',
SUPERADMIN_HISTORY_GET_TABLE = 'superadmin/history',
    FORGOT_PASSWORD = 'forgot-password',
    CHANGE_PASSWORD = 'change-password',
    RESET_PASSWORD = 'reset-password',
    SUPERADMIN_ADD_EDIT = 'superadmin',
    SUPERADMIN_GET_TABLE = 'superadmin/table/get',

    TAG_GET_TABLE = 'product-tag/table/get',
    TAG_ADD_EDIT = 'product-tag',

    CATEGORY_GET_TABLE = 'product-category/table/get',
    CATEGORY_ADD_EDIT = 'product-category',
    GET_CATEGORY_HISTORY = 'product-category/history',

    USERS_GET_TABLE = 'user/table/get',
    USERS_ADD_EDIT = 'user',

    COMPANY_GET_TABLE = 'company/table/get',
    COMPANY_ADD_EDIT = 'company',

    DASHBOARD_COUNT = 'dashboard/count',
    
    //Category
    CATEGORIES_GET_TABLE = 'product-category/table/get',

    //Product for courses
    PRODUCT_GET_TABLE = 'product/table/get',
    GET_PRODUCT = 'product',
    SAVE_CART = 'cart',
    CART = 'cart',
    PRODUCTS = '/products',
    GET_ALL_CERTIFICATES = 'product/certificates/all',
    GET_ALL_MULTIMEDIA = 'product-multi-media',
    UPLOAD_PRODUCT_LOGO = 'upload-attachment',

    // Plan
    PLAN_GET_TABLE = 'plan/table/get',
    PLAN_ADD_EDIT = 'plan',
    MODIFY_PLAN_POSITION ='plan/modify-order',
    
    //Banner
    BANNER_GET_TABLE = 'banner/table/get',
    BANNER = 'banner',
    MODIFY_BANNER_POSITION ='banner/modify-order',
    
    // Company registration
    CHECK_COMPANY = 'company/check',
    CREATE_COMPANY = 'company/sign-up',
    REGISTRATION_COMPANY = 'company/registration',

    // Setting get api for country, state, city
    GET_ALL_COUNTRIES ='setting/countries',

    //Sign up
    SIGN_UP = 'user/sign-up',

    //Company Course category
    COMPANY_CATEGORY_GET_TABLE = 'product-category/company/table',
    COMPANY_CATEGORY_COURSE_GET_TABLE = 'subscription/company/table',


}